import { MenuItem, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";

export const gradeOptions = [
  "N/A",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
] as const;

export type GradeType = (typeof gradeOptions)[number];

type GradeSelectProps = {
  grade: number;
  onChange: (grade: number) => void;
  required?: boolean;
  disabled?: boolean;
};

const useStyle = makeStyles((theme) => ({
  gridItem: {
    padding: "0px !important",
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

export function GradeSelect(props: GradeSelectProps) {
  const classes = useStyle();
  const grades = ["N/A", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

  return (
    <TextField
      className={classes.inputText}
      value={props.grade}
      onChange={(e) => props.onChange(Number(e.target.value))}
      label="Academic level"
      disabled={props.disabled}
      required={props.required}
      fullWidth
      select>
      {grades.map((grade, index) => (
        <MenuItem key={grade} value={index}>
          {grade}
        </MenuItem>
      ))}
    </TextField>
  );
}
